import { LegalLayout } from '../../../components/layout/LegalLayout';

export default function CgvCourtier() {
  return (
    <LegalLayout
      title="CGV — Courtier en énergie B2B"
      url="https://solutionecofrance.fr/legal/cgv-courtier-energie"
      lastUpdated="01/05/2026"
    >
      <p>
        Les présentes Conditions Générales de Vente (ci-après <em>« CGV »</em>) régissent
        exclusivement les prestations de <strong>courtage en énergie destinées aux
        professionnels (B2B)</strong> exercées par la société{' '}
        <strong>SOLUTION ÉCO FRANCE</strong> (SAS, SIREN 982 431 033 — ci-après{' '}
        <em>« le Courtier »</em>) au profit de toute personne morale ou professionnelle
        souscrivant un mandat de courtage (ci-après <em>« le Client »</em>).
      </p>
      <p>
        Pour les autres pôles d’activité de Solution Éco France — pôle{' '}
        <em>Travaux & Rénovation</em> et pôle <em>Mandataire CEE</em> — des conditions
        contractuelles spécifiques s’appliquent et sont remises au Client préalablement à toute
        commande.
      </p>

      <h2>1. Définitions</h2>
      <ul>
        <li>
          <strong>Courtier :</strong> Solution Éco France, exerçant une activité d’intermédiation
          entre fournisseurs d’énergie et professionnels.
        </li>
        <li>
          <strong>Fournisseur :</strong> opérateur autorisé à commercialiser de l’électricité
          et/ou du gaz naturel sur le territoire français (TotalEnergies, Engie, EDF Pro, Eni,
          Alpiq, Vattenfall, OHM Énergie, Octopus Energy, ekWateur, Plüm Énergie, Mint Énergie,
          Alterna, etc.).
        </li>
        <li>
          <strong>Mandat de courtage :</strong> document écrit par lequel le Client autorise le
          Courtier à le représenter auprès des Fournisseurs.
        </li>
        <li>
          <strong>Site(s) :</strong> point(s) de livraison (PDL pour l’électricité, PCE pour le
          gaz) couverts par le mandat.
        </li>
        <li>
          <strong>Segment tarifaire :</strong> classification du site (C5, C4, C3, C2 pour
          l’électricité ; T1, T2, T3, T4 pour le gaz).
        </li>
      </ul>

      <h2>2. Objet du contrat</h2>
      <p>
        Le Courtier s’engage à fournir au Client les prestations suivantes :
      </p>
      <ul>
        <li>analyse des consommations historiques et du profil de soutirage ;</li>
        <li>audit des factures actuelles (TURPE/ATRD, taxes, contributions) ;</li>
        <li>
          comparaison transparente des offres disponibles auprès de l’ensemble des Fournisseurs
          accessibles au profil tarifaire du Client ;
        </li>
        <li>négociation directe auprès des Fournisseurs retenus ;</li>
        <li>
          présentation d’un comparatif chiffré et restitution des conditions complètes (prix,
          durée, indexation, options vertes, conditions de sortie) ;
        </li>
        <li>
          accompagnement à la signature et au transfert (relève contradictoire, suspension de
          l’ancien contrat, mise en service du nouveau) ;
        </li>
        <li>renégociation à échéance et veille tarifaire pendant la durée du mandat.</li>
      </ul>

      <h2>3. Statut du Courtier — indépendance vis-à-vis des Fournisseurs</h2>
      <p>
        Sur le pôle Courtage énergie B2B uniquement, Solution Éco France est{' '}
        <strong>indépendante des Fournisseurs d’énergie</strong> :
      </p>
      <ul>
        <li>
          aucun lien capitalistique direct ou indirect avec un Fournisseur ;
        </li>
        <li>
          aucun partenariat exclusif ni accord de référencement payant restrictif ;
        </li>
        <li>
          la comparaison inclut systématiquement l’ensemble des Fournisseurs accessibles au
          profil tarifaire du Client.
        </li>
      </ul>
      <p>
        Cette indépendance est strictement limitée au pôle Courtage : sur les pôles{' '}
        <em>Travaux</em> et <em>Mandataire CEE</em>, Solution Éco France entretient des
        partenariats commerciaux assumés.
      </p>

      <h2>4. Mandat de courtage</h2>
      <p>
        Conformément aux articles L. 132-1 et suivants du Code de commerce, l’intervention du
        Courtier est subordonnée à la signature préalable d’un mandat de courtage. Ce mandat
        précise : l’identité des parties, les Sites couverts, sa durée, les prestations
        confiées, la rémunération du Courtier (cf. article 5), les modalités de résiliation et
        les conditions de transmission des données.
      </p>
      <p>
        Le mandat est non exclusif sauf mention expresse contraire acceptée par le Client. Il
        peut être révoqué à tout moment par lettre recommandée avec accusé de réception, sous
        réserve d’un préavis raisonnable et du paiement des prestations déjà accomplies.
      </p>

      <h2>5. Rémunération du Courtier</h2>
      <p>
        La rémunération du Courtier provient exclusivement d’une <strong>commission versée par
        le Fournisseur retenu</strong>, comprise entre <strong>1,5 % et 4 %</strong> du montant
        hors taxes du contrat selon le segment tarifaire et le volume engagé. Cette commission
        est :
      </p>
      <ul>
        <li>
          <strong>communiquée par écrit au Client avant signature</strong> du mandat ou, à
          défaut, avant signature du contrat de fourniture ;
        </li>
        <li>
          <strong>intégrée au prix communiqué</strong> (le Client ne paie aucun supplément
          direct) ;
        </li>
        <li>
          détaillée dans une annexe spécifique de chaque proposition commerciale, conformément
          aux exigences de transparence du médiateur national de l’énergie.
        </li>
      </ul>
      <p>
        Aucune commission cachée, rétro-commission ou avantage en nature non déclaré n’est
        perçu.
      </p>

      <h2>6. Obligations du Courtier</h2>
      <ul>
        <li>
          <strong>Obligation de moyens renforcée :</strong> diligence, loyauté, transparence
          envers le Client ;
        </li>
        <li>
          <strong>Conseil objectif :</strong> recommandation justifiée, en fonction du seul
          intérêt du Client ;
        </li>
        <li>
          <strong>Information précontractuelle complète</strong> sur les contrats proposés
          (durée, indexation, options vertes, conditions de résiliation, garanties d’origine) ;
        </li>
        <li>
          <strong>Confidentialité</strong> des données commerciales et énergétiques transmises ;
        </li>
        <li>
          <strong>Conservation</strong> des pièces contractuelles selon les durées légales
          (cf. <a href="/legal/politique-confidentialite">politique de confidentialité</a>).
        </li>
      </ul>

      <h2>7. Obligations du Client</h2>
      <ul>
        <li>
          fournir des informations exactes, complètes et à jour (SIRET, RIB, factures
          actuelles, courbes de charge, puissance souscrite, options) ;
        </li>
        <li>
          signer le mandat de courtage et ne pas mandater simultanément un autre courtier sur
          les mêmes Sites pendant la durée du mandat (sauf mandat non exclusif) ;
        </li>
        <li>
          répondre dans des délais raisonnables aux sollicitations nécessaires à
          l’aboutissement du dossier ;
        </li>
        <li>
          informer le Courtier de tout changement substantiel (cession de site, modification de
          puissance, fusion, redressement…).
        </li>
      </ul>

      <h2>8. Confidentialité</h2>
      <p>
        Chaque partie s’engage à conserver confidentielles l’ensemble des informations
        commerciales, techniques et financières transmises dans le cadre du présent contrat,
        pendant toute la durée du mandat et pour une durée de 3 ans après son terme. Cette
        obligation ne s’applique pas aux informations publiques ou exigées par autorité
        légalement habilitée.
      </p>

      <h2>9. Responsabilité</h2>
      <p>
        Le Courtier est tenu d’une <strong>obligation de moyens</strong>. Sa responsabilité est
        limitée :
      </p>
      <ul>
        <li>
          à la qualité de l’analyse et à l’exactitude de la comparaison réalisée à partir des
          données transmises par le Client ;
        </li>
        <li>
          aux préjudices directs, prévisibles et certains imputables à un manquement avéré du
          Courtier ;
        </li>
        <li>
          à un montant maximal correspondant aux honoraires (commissions) effectivement
          perçus par le Courtier au titre du dossier concerné, sauf faute lourde ou dolosive.
        </li>
      </ul>
      <p>
        Le Courtier ne saurait être tenu responsable des conditions finales arrêtées par le
        Fournisseur, des évolutions tarifaires ultérieures à la signature, ni des conséquences
        des choix de gestion énergétique du Client.
      </p>

      <h2>10. Force majeure</h2>
      <p>
        Conformément à l’article 1218 du Code civil, aucune des parties n’est responsable de
        l’inexécution de ses obligations en cas de force majeure (catastrophes naturelles,
        guerres, attentats, grèves d’ampleur nationale, défaillances majeures des
        infrastructures de communication, décisions des autorités publiques affectant la
        fourniture d’énergie, etc.).
      </p>

      <h2>11. Durée et résiliation</h2>
      <p>
        Le mandat est conclu pour la durée qu’il précise (typiquement 12 à 24 mois). Il prend
        fin de plein droit à son échéance, sauf reconduction expresse. Chaque partie peut le
        résilier de manière anticipée pour manquement grave de l’autre partie, après mise en
        demeure restée sans effet pendant 30 jours.
      </p>

      <h2>12. Données personnelles</h2>
      <p>
        Les traitements de données personnelles afférents au mandat sont décrits dans notre{' '}
        <a href="/legal/politique-confidentialite">politique de confidentialité</a>.
      </p>

      <h2>13. Médiation et règlement amiable</h2>
      <p>
        En cas de litige, les parties s’engagent à rechercher une solution amiable préalable.
        À défaut, le Client peut saisir gratuitement le{' '}
        <strong>Médiateur national de l’énergie</strong> :
      </p>
      <ul>
        <li>Libre réponse n° 59252, 75443 Paris Cedex 09</li>
        <li>
          <a href="https://www.energie-mediateur.fr" rel="noopener noreferrer" target="_blank">
            energie-mediateur.fr
          </a>
        </li>
      </ul>

      <h3>13.1. Médiateur de la consommation</h3>
      <p>
        En cas de litige entre le professionnel et le consommateur, ceux-ci s’efforceront de
        trouver une solution amiable.
      </p>
      <p>
        À défaut d’accord amiable, le consommateur a la possibilité de saisir gratuitement le
        médiateur de la consommation dont relève le professionnel, à savoir l’
        <strong>AME CONSO</strong>, dans un délai d’un an à compter de la réclamation écrite
        adressée au professionnel.
      </p>
      <p>La saisine du médiateur de la consommation devra s’effectuer :</p>
      <ul>
        <li>
          soit en complétant le formulaire prévu à cet effet sur le site internet de l’AME
          CONSO :{' '}
          <a
            href="https://www.mediationconso-ame.com"
            rel="noopener noreferrer"
            target="_blank"
          >
            www.mediationconso-ame.com
          </a>{' '}
          ;
        </li>
        <li>
          soit par courrier adressé à l’AME CONSO, 197 Boulevard Saint-Germain — 75007 PARIS.
        </li>
      </ul>

      <h2>14. Loi applicable et juridiction</h2>
      <p>
        Les présentes CGV sont régies par le <strong>droit français</strong>. À défaut de
        résolution amiable, tout litige relèvera de la compétence exclusive du{' '}
        <strong>Tribunal de commerce</strong> du ressort du siège social du Courtier.
      </p>

      <h2>15. Acceptation des CGV</h2>
      <p>
        La signature du mandat de courtage emporte acceptation pleine et entière des présentes
        CGV par le Client, qui reconnaît en avoir pris connaissance préalablement et avoir reçu
        toutes les informations utiles à son consentement éclairé.
      </p>
    </LegalLayout>
  );
}
